import React from 'react';

export type WithInvalidState = {
  state?: unknown;
};

export function withInvalidState<P extends WithInvalidState>(Component: React.ComponentType<P>) {
  return (props: P) => {
    if (!props.state) {
      // this error will be caught by error boundary
      throw new Error('Controller not initialized. Cannot render without props.');
    }

    return <Component {...props} />;
  };
}
